import { useEffect } from 'react';
import { Language } from './useLanguage';

const LANGUAGE_STORAGE_KEY = 'userBrowserLanguage';

export const defaultLanguage = 'en';

const detectBrowserLanguage = (): Language => {
  if (typeof navigator !== 'undefined' && navigator.language) {
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('ar')) {
      return 'ar';
    }
  }
  return defaultLanguage;
};

export const useBrowserLanguage = (country?: string) => {
  const getStoredLanguage: () => Language = () => {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) === 'ar' ? 'ar' : defaultLanguage;
  };

  const setLanguage = (language: string) => {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);

    // If no language is stored, determine it based on priority:
    // 1. Country (if SA, set to Arabic - this happens after API response)
    // 2. Browser language (if Arabic, set to Arabic)
    // 3. Default to English
    if (!storedLanguage) {
      let detectedLanguage: Language = defaultLanguage;

      if (country === 'SA') {
        // For Saudi Arabia, default to Arabic
        detectedLanguage = 'ar';
      } else {
        // For other countries or when country is not available, check browser language
        detectedLanguage = detectBrowserLanguage();
      }

      localStorage.setItem(LANGUAGE_STORAGE_KEY, detectedLanguage);
    }
  }, [country]);

  // Return current language value so components can react to changes
  const currentLanguage = getStoredLanguage();

  return {
    getStoredLanguage,
    setLanguage,
    currentLanguage,
  };
};
